import { render, staticRenderFns } from "./DocumentScanner.vue?vue&type=template&id=2914a208&"
import script from "./DocumentScanner.vue?vue&type=script&lang=js&"
export * from "./DocumentScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports